<template>
    <v-layout wrap>
        <v-flex xs12>
            <v-card class="card--flex-toolbar">
                <v-toolbar
                    flat
                >
                    <v-btn
                        icon
                        @click="$router.back()"
                    >
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-toolbar-title class="grey--text">Cupones de: {{ cliente !== null ? nombreCliente : '' }}</v-toolbar-title>
                    <v-spacer/>
                    <v-dialog
                        v-show="cliente"
                        v-model="dialog"
                        max-width="900px"
                        persistent
                        scrollable
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                color="primary"
                                dark
                                class="mb-2"
                                v-on="on"
                            >
                                Agregar cupón
                            </v-btn>
                        </template>
                        <v-card>
                            <form-agregar-cupon
                                v-if="dialog"
                                :nombre-cliente="nombreCliente"
                                :cliente-id="cliente.id"
                                :type-action="typeAction"
                                @close="dialog = false;typeAction = 'add'"
                                @save="saveItem(); typeAction = 'add'"
                            />
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </v-card>
        </v-flex>
        <v-flex
            grow
            pt-2
        >
            <v-data-table
                :headers="headers"
                :items="cupones"
                :options.sync="options"
                :sort-by="['created_at']"
                :sort-desc="[false, true]"
                class="elevation-1"
                :footer-props="{itemsPerPageOptions : $root.OPTIONS_PER_PAGE_DATATABLE}"
                :loading="loading"
                :server-items-length="cuponesTotal"
                @update:options="listar"
            >
                <template v-slot:item.tipo_cupon_id="{item}">
                    <v-avatar
                        tile
                        size="48px"
                        color="grey lighten-4"
                    >
                        <img
                            :src="item.tipo_cupones.img_url"
                            alt="avatar"
                        >
                    </v-avatar>
                    {{item.tipo_cupones.nombre }}
                </template>
                <template v-slot:items="props">
                    <td class="text-center">
                        {{ props.item.cantidad }}
                    </td>
                    <td>{{ props.item.created_at }}</td>
                    <td class="justify-center layout px-0">
                    </td>
                </template>
                <template v-slot:item.actions="{item}">
                    <v-tooltip left>
                        <template v-slot:activator="{ on }">
                            <v-icon
                                small
                                class="mr-2"
                                v-on="on"
                                @click="editItemId(item.id); dialog_timeline = true;"
                                v-text="'mdi-timeline-text-outline'"
                            >
                            </v-icon>
                        </template>
                        <span>Ver historial</span>
                    </v-tooltip>
                    <v-tooltip left>
                        <template v-slot:activator="{ on }">
                            <v-icon
                                small
                                class="mr-2"
                                v-on="on"
                                @click="dialog = true; typeAction='exchange'"
                                v-text="'mdi-autorenew'"
                            >
                            </v-icon>
                        </template>
                        <span>Canjear cupones</span>
                    </v-tooltip>
                </template>
            </v-data-table>
        </v-flex>
        <v-dialog
            v-model="dialog_timeline"
            max-width="800px"
            persistent
        >
            <timeline-cupon

                :timeline="timelineItemSelect"
                @form:close="close();dialog_timeline = false"
            />
        </v-dialog>
    </v-layout>
</template>

<script>
    import FormAgregarCupon from '@components/FormAgregarCupon';
    import TimelineCupon from '@components/TimelineCupon';
    import axios from 'axios';

    import EventBus from "../../EventBus";

    export default {
        name: "ClientesCupones",
        components: {
            FormAgregarCupon,
            TimelineCupon
        },
        props: {
            clienteId: {
                type: Number,
                default: 0,
            }
        },
        data(){
            return {
                cliente: null,
                dialog: false,
                dialog_timeline: false,
                dialog_delete: false,
                headers: [
                    {
                        text: 'Tipo cupón',
                        align: 'left',
                        sortable: false,
                        value: 'tipo_cupon_id'
                    },
                    {
                        text: 'Disponibles',
                        align: 'center',
                        sortable: false,
                        value: 'cantidad'
                    },
                    {
                        text: 'Fecha registro',
                        align: 'left',
                        sortable: true,
                        value: 'created_at'
                    },
                    {text: 'Opciones', value: 'actions', sortable: false}
                ],
                filter: {
                    desde: null,
                    hasta: null,
                },
                modal_desde: false,
                modal_hasta: false,
                cupones: [],
                cuponesTotal : 0,
                itemSelectId: 0,
                itemDelete: null,
                loading: false,
                loading_delete: false,
                options: {
                    descending:true,
                    page:1,
                    itemsPerPage: this.$root.OPTIONS_PER_PAGE_DATATABLE[0],
                    totalItems:0
                },
                typeAction: 'add'
            }
        },
        computed: {
            nombreCliente() {
                if (this.cliente) {
                    return this.cliente.nombre + ' ' + this.cliente.apellido_paterno + ' ' + this.cliente.apellido_materno;
                }
                return '';
            },
            timelineItemSelect() {
                if (this.itemSelectId > 0) {
                    let cupon = this.cupones.find((item) => item.id == this.itemSelectId);
                    return cupon.timeline;
                }
                return [];
            }
        },
        watch: {
            dialog(val) {
                val || this.close()
            }
        },
        created() {
            this.initialize()
        },
        mounted() {
            if (this.clienteId === 0) {
                EventBus.$emit('tugarrafon:show-snackbar', {
                    color: 'warning',
                    text_content: 'Debes elegir un cliente'
                });
                this.$router.back();
            } else {
                this.loadCliente();
            }
        },
        methods: {
            initialize() {
            },
            close() {
                this.itemSelectId = 0;
            },
            editItemId(itemId) {
                this.itemSelectId = parseInt(itemId);
            },
            deleteItem() {
                this.loading_delete = true;
                axios.post('api/clientes/eliminar/' + this.itemDelete.id)
                    .then((response) => {
                        this.loading_delete = false;
                        let {data} = response;
                        if (data.success) {
                            this.snackbar_config.color = 'success';
                            this.snackbar_config.text_content = data.message;
                            this.snackbar = true;
                            this.itemDelete = null;
                            this.dialog_delete = false;
                            this.listar();
                        }
                    })
                    .catch((error) => {
                        this.loading_delete = false;
                        this.snackbar_config.color = 'error';
                        if (error.response && error.response.data) {
                            this.snackbar_config.text_content = error.response.data.message;
                            this.snackbar = true;
                        } else {
                            this.snackbar_config.text_content = 'Error durante la petición';
                            this.snackbar = true;
                        }
                    })
            },
            deleteItemConfirm(item) {
                this.itemDelete = item;
                this.dialog_delete = true;
            },
            listar() {
                this.loading = true;
                const {sortBy, descending, page, itemsPerPage} = this.options;
                axios.get('/api/clientes/cupones/listar/' + this.clienteId, {
                    params: {
                        sortBy: sortBy, descending: descending, page: page, rowsPerPage: itemsPerPage,
                        search: this.search,
                        ...this.filter
                    }
                }).then((success) => {
                    this.loading = false;
                    let {data} = success;
                    this.cupones = data.data.data;
                    this.options.page = data.data.current_page;
                    this.cuponesTotal = data.data.total;
                }).catch(() => {
                    this.loading = false;

                    EventBus.$emit('tugarrafon:show-preloader', {text_content: 'Error durante la petición'})
                });
            },
            loadCliente() {
                axios.get('/api/clientes/ver/' + this.clienteId)
                    .then((resultOk) => {
                        this.cliente = resultOk.data.data;
                    })
                    .catch(() => {
                        EventBus.$emit('tugarrafon:show-snackbar', {
                            color: 'error',
                            text_content: 'No pudimos obtener la información del cliente'
                        });
                        this.$router.back();
                    });
            },
            saveItem() {
                this.dialog = false;
                this.listar();
            }
        }
    }
</script>

<style scoped>

</style>
